/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profilebillingorganization2Inputs */

const en_profilebillingorganization2 = /** @type {(inputs: Profilebillingorganization2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (organization)`)
};

const de_profilebillingorganization2 = /** @type {(inputs: Profilebillingorganization2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (Organisation)`)
};

/**
* | output |
* | --- |
* | "{name} (organization)" |
*
* @param {Profilebillingorganization2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingorganization2 = /** @type {((inputs: Profilebillingorganization2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingorganization2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingorganization2(inputs)
	return de_profilebillingorganization2(inputs)
});
export { profilebillingorganization2 as "profileBillingOrganization" }